export default __webpack_public_path__ + "static/media/favicon.0fbae51c.ico";